import React from "react";
import { TOOLS } from "../mock";

export default function ToolsMarquee() {
  const items = [...TOOLS, ...TOOLS];
  return (
    <section className="border-y border-white/5 py-6 lg:py-8 overflow-hidden bg-[#0d0d0d]">
      <div className="container-max flex items-center gap-6 mb-4">
        <span className="section-label">Tool & piattaforme</span>
      </div>
      <div className="relative flex overflow-hidden">
        <div className="marquee flex gap-12 whitespace-nowrap px-6">
          {items.map((t, i) => (
            <span key={i} className="font-display text-2xl lg:text-3xl text-white/40 hover:text-white transition-colors">
              {t} <span className="text-white/20 ml-12">•</span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
